import React from 'react';

import MUIDialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  dialogPaper: {
    maxHeight: 'calc(100% - 32px)',
    margin: '16px'
  }
}));

export default function Dialog(props) {
  const styleClasses = useStyles();

  const { classes = {}, fulllScreen, children, ...rest } = props;

  let customClasses = {
    ...classes
  };

  if (fulllScreen) {
    customClasses = {
      ...customClasses,
      ...{
        paper: styleClasses.dialogPaper
      }
    };
    rest.maxWidth = 'lg';
  }

  return (
    <MUIDialog classes={customClasses} {...rest}>
      {children}
    </MUIDialog>
  );
}
